import { yupResolver } from "@hookform/resolvers/yup";
import { FunctionComponent, useState } from "react";
import { useForm, SubmitHandler } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import { Button } from "src/components/generic";
import { TermsAndConditions, TextInputWithRegister } from "src/components/inputs";
import { auth, dynamo, format, forms, informativ } from "src/utils";
import convert from 'xml-js';
import axios from 'axios';

const ConsultantRegistrationForm: FunctionComponent = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string>('');

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: {
            name: "",
            email: "",
            password: "",
            phone: "",
            termsAndConditions: false
        },
        resolver: yupResolver(forms.schema.ConsultantRegistrationSchema)
    });

    const submit: SubmitHandler<any> = async (data) => {
        const { email, password, name } = data;

        try {
            // register cognito
            const result = await auth.cognito.registerCognitoUser(email, password);
            const uid = result?.userSub || `${Math.random().toFixed(4)}-${Math.random().toFixed(4)}`.replaceAll('.', 'e');
            
            // register informative
            const ipResult = await axios.get('https://api.ipify.org?format=json');
            const informativResult = await informativ.creditUsers.addCreditUser({
                uid, name, email, password,
                ip: ipResult.data.ip
            });
            const convertedResult = convert.xml2js(informativResult, { compact: true });

            // register dynamo
            const consultant = format.users.userDataToConsultant(data, uid);

            //@ts-ignore
            consultant.metadata.cus_id = convertedResult["XML_INTERFACE"]["CUS_ID"]["_text"];
            
            await dynamo.mutations.putUser(consultant);

            // confirm account
            navigate(`/auth/confirm-account?email=${email}`);
        } catch (error: any) {
            setError(error?.message || 'Failed to Register');
        }
    }

    return (
        <form>
            {error && <p>{error}</p>}
            <TextInputWithRegister
                label='Name'
                id='name'
                placeholder='Full name...'
                containerStyles='lg:w-[85%]'
                register={register('name')}
                error={errors?.name?.message}
            />

            <TextInputWithRegister
                label='Email'
                id='email'
                placeholder='Email address...'
                containerStyles='lg:w-[85%]'
                register={register('email')}
                error={errors?.email?.message}
            />

            <TextInputWithRegister
                label='Password'
                id='password'
                placeholder='Enter strong password...'
                containerStyles='lg:w-[85%]'
                register={register('password')}
                password
                showPasswordToggle
                error={errors?.password?.message}
            />

            <TextInputWithRegister
                label='Phone'
                id='phone'
                placeholder='Phone number...'
                containerStyles='lg:w-[85%]'
                register={register('phone')}
                error={errors?.phone?.message}
            />

            <TermsAndConditions
                register={register}
                error={errors?.termsAndConditions?.message}
            />

            <Button text="Submit" onClick={handleSubmit(submit)} />
        </form>
    )
}

export default ConsultantRegistrationForm;